import { cn } from "@/lib/utils"

interface SectionLabelProps {
  className?: string
  children: React.ReactNode
}

export function SectionLabel({ className, children }: SectionLabelProps) {
  return (
    <div
      className={cn(
        "text-[11px] font-medium uppercase tracking-[0.08em] text-grey5",
        className,
      )}
    >
      {children}
    </div>
  )
}
